import React, { useState } from 'react';
import { Card } from './../Card/Card';
import classNames from 'classnames';
import { OrderDateTimeConfirmationModal } from '../RouteOrder/OrderDateTimeConfirmationModal';

export const RouteTools = ({ route, hasReturnPicking = false, onOpenRouteDelayModal }) => {
  const  { id } = route;

  const [isOrderConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);

  const handleSmsModalClose = () => setIsConfirmationModalOpen(false);
  const handleSmsModalOpen = () => setIsConfirmationModalOpen(true);

  return (
    <Card title={__('routes.tools')}>
      <a type="button" className="btn btn-secondary mr-5px mt-5px" href={`/admin/routes/edit/${id}`}>{__('routes.edit')}</a>
      {!hasReturnPicking && (
        <a type="button" className="btn btn-primary mr-5px mt-5px" href={`/admin/routes/shippingletter/${id}`} target="_blank">{__('routes.print_shipping_letter')}</a>
      )}
      <a type="button" className="btn btn-primary mr-5px mt-5px" href={`/admin/routes/list/${id}`} target="_blank">{__('routes.print_list')}</a>
      {!hasReturnPicking && (
        <>
          <a type="button" className="btn btn-primary mr-5px mt-5px" href={`/admin/routes/income-list/${id}`} target="_blank">{__('routes.print_income_list')}</a>
          <a type="button" className="btn btn-primary mr-5px mt-5px" href={`/admin/routes/cmr/${id}`} target="_blank">{__('routes.print_cmr')}</a>
        </>
      )}
      {!hasReturnPicking && (
        <>
          <button
            type="button"
            className="btn btn-danger mr-5px mt-5px"
            onClick={handleSmsModalOpen}
          >
            {__('routes.ask_for_confirmation')}
          </button>

          <OrderDateTimeConfirmationModal
            isOpen={isOrderConfirmationModalOpen}
            onModalClose={handleSmsModalClose}
            routeId={id}
          />
        </>
      )}

      <a type="button" className={classNames({'btn btn-info mr-5px mt-5px': true, 'disabled': route.isReadyForLoading})} href={`/admin/routes/toggleready/${id}`}>
        {route.isReady ? __('routes.set_as_not_ready') : __('routes.set_as_ready')}
      </a>

      <a type="button" className="btn btn-warning mr-5px mt-5px" href={`/admin/routes/setsent/${id}`}>{__('routes.set_as_sent')}</a>
      <a type="button" className="btn btn-success mr-5px mt-5px" href={`/admin/routes/setdone/${id}`}>{__('routes.set_as_done')}</a>
      {!hasReturnPicking && (
        <>
          <a type="button" className="btn btn-danger mr-5px mt-5px" href={`/admin/routes/${id}/failures`}>{__('routes.notify_failure_info')}</a>
          <button type="button" className="btn btn-secondary mr-5px mt-5px" onClick={onOpenRouteDelayModal}>{__('routes.notify_delay_info')}</button>
        </>
      )}
      {!hasReturnPicking && (
        <a type="button" className="btn btn-primary mr-5px mt-5px" href={`/admin/orders/route/${id}/shipping-labels`}>{__('routes.print_return_and_exchange_shipping_labels')}</a>
      )}
    </Card>
  );
};
